module.exports = __webpack_public_path__ + "ff2d468a1a5028d6818ff3619e9eabef.jpg";